import React from 'react';
import FavoritePlan from './Favorite/FavoritePlan';
import PlanCard, {
  PlanCardProps,
} from '../../core/Plans/PlanCard/components/PlanCard';

export type CardProps = PlanCardProps & {
  id: number;
  favoriteCount: number;
  isFavorite: boolean;
  isAuthenticated: boolean;
  defaultIsVisible?: boolean;
  onChange?: (id: number, favorite: boolean, favoriteCount: number) => void;
};

const Card = ({
  id,
  favoriteCount,
  isFavorite,
  isAuthenticated,
  onChange,
  onClick,
  title,
  ...planCardProps
}: CardProps) => {
  return (
    <PlanCard
      mediaButton={
        <FavoritePlan
          buttonType="rounded"
          planId={id}
          planName={title}
          favoriteCount={favoriteCount}
          isFavorite={isFavorite}
          isAuthenticated={isAuthenticated}
          onChange={onChange}
        />
      }
      onClick={onClick}
      title={title}
      {...planCardProps}
    />
  );
};

export default Card;
